import BusinessEmail from "./validation/business-email"
import ActiveCustomer from "./validation/active-customer"

class FormValidation {
	constructor(drForm) {
		// Disable showing of form validation alert
		window.alert = function () {
			return false;
		}

		// Disable scrolling to form fields with a validation errors
		HTMLInputElement.prototype.scrollIntoView = function() {
			let header_offset = 128;
			let scroll_distance = this.getBoundingClientRect().top + window.scrollY - document.documentElement.clientTop - header_offset;

			if (typeof UIkit !== 'undefined') {
				UIkit.scroll('input', {offset: header_offset}).scrollTo(this);
			} else {
				window.scrollTo({
					top: scroll_distance,
					left: 0,
					behavior: "smooth",
				});
			}
		};

		// Apply custom validation
		if (drForm.dataset['validbusinessemail']) {
			new BusinessEmail(drForm);
		}
		if (drForm.dataset['validactivecustomer']) {
			new ActiveCustomer(drForm);
		}
	}
}

export default FormValidation;
